import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    BusinessUser: {}, // 後台使用者資料
    getRoleList: [], // 角色清單
    AllBookInfo: {}, // 網路清單
    AllLiveBookInfo: {}, // 現場清單
    GetOpenTime: [], // 店家所有營業時間
    roleOpenTime: [],
    isLoading: false
  },
  mutations: {
    BusinessUserData (state, data) {
      state.BusinessUser = data
    },
    RoleList (state, data) {
      state.getRoleList = data
    },
    bookInfo (state, data) {
      state.AllBookInfo = data
    },
    liveBookInfo (state, data) {
      state.AllLiveBookInfo = data
    },
    updatePermissions (state, data) {
      state.getRoleList[data.index].BusinessRoleAuthority = data.str
    },
    updateRoleData (state, message) {
      if (message.str === 'name') {
        state.getRoleList[message.index].BusinessRoleName = message.message
      } else {
        state.getRoleList[message.index].Email = message.message
      }
    },
    OpenTime (state, data) {
      state.GetOpenTime = data
    },
    updateOpenTime (state, message) {
      const upd = 'Update'
      if (message.str === 'CheckInHour') {
        const [, , c, d, e] = state.GetOpenTime[message.index].CheckIn
        state.GetOpenTime[message.index].CheckIn = `${message.message +
          c +
          d +
          e}`
        state.GetOpenTime[message.index].upd = upd
      } else if (message.str === 'CheckInMinute') {
        const [a, b, c] = state.GetOpenTime[message.index].CheckIn
        state.GetOpenTime[message.index].CheckIn = `${a +
          b +
          c +
          message.message}`
        state.GetOpenTime[message.index].upd = upd
      } else if (message.str === 'CheckOutHour') {
        const [, , c, d, e] = state.GetOpenTime[message.index].CheckOut
        state.GetOpenTime[message.index].CheckOut = `${message.message +
          c +
          d +
          e}`
        state.GetOpenTime[message.index].upd = upd
      } else if (message.str === 'CheckOutMinute') {
        const [a, b, c] = state.GetOpenTime[message.index].CheckOut
        state.GetOpenTime[message.index].CheckOut = `${a +
          b +
          c +
          message.message}`
        state.GetOpenTime[message.index].upd = upd
      }
    },
    roleTime (state, data) {
      var list = state.roleOpenTime
      if (data.str === 'btn') {
        list[data.order].Week[data.index].Enable = !list[data.order].Week[
          data.index
        ].Enable
        state.roleOpenTime = list
      } else if (data.str === 'people') {
        list[data.order].Week[data.index].People = data.int
        state.roleOpenTime = list
      } else {
        state.roleOpenTime = data
      }
    },
    searchData (state, data) {
      console.log(data)
    },
    loading (state, val) {
      state.isLoading = val
    }
  },
  actions: {
    // 取得目前後台登入的人的資訊
    BusinessUser (context) {
      const adminEmail = JSON.parse(sessionStorage.getItem('admin'))
      Vue.axios
        .get('http://imrebooksystem.rocket-coding.com/BusinessUsers/GetUserInfo', {
          params: { email: adminEmail }
        })
        .then(function (res) {
          context.commit('BusinessUserData', res.data)
          const id = res.data.Id
          // 取得 網路 預約資料與目前所有預約號碼
          Vue.axios
            .get('http://imrebooksystem.rocket-coding.com/Dashboard/AllBookInfo', {
              params: { id: id }
            })
            .then(function (res) {
              context.commit('bookInfo', res.data)
            })
            .catch(error => console.error(error))
          // 取得角色清單
          Vue.axios
            .get('http://imrebooksystem.rocket-coding.com/BusinessRoles/GetRoleList', {
              params: { id: id }
            })
            .then(res => {
              context.commit('RoleList', res.data)
              const roleList = res.data
              // 取得 現場 預約資料與目前所有預約號碼
              Vue.axios
                .get('http://imrebooksystem.rocket-coding.com/Dashboard/AllLiveBookInfo', {
                  params: { id: id }
                })
                .then(function (res) {
                  res.data.NetWorkBookInfo.forEach(element => {
                    roleList.forEach(item => {
                      if (element.BusinessRoleId === item.Id) {
                        element.roleName = item.BusinessRoleName
                      }
                    })
                  })
                  context.commit('liveBookInfo', res.data)
                })
                .catch(error => console.error(error))
            })
            .catch(error => {
              console.error(error)
            })
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 取得店家營業時間
    GetOpenTime (context, message) {
      context.commit('loading', true)
      const adminEmail = JSON.parse(sessionStorage.getItem('admin'))
      Vue.axios
        .get('http://imrebooksystem.rocket-coding.com/BusinessUsers/GetUserInfo', {
          params: { email: adminEmail }
        })
        .then(res => {
          Vue.axios
            .get('http://imrebooksystem.rocket-coding.com/BusinessOpenTimes/GetOpenTime', {
              params: { id: res.data.Id }
            })
            .then(function (res) {
              if (message === undefined) {
                context.commit('OpenTime', res.data)
                context.commit('loading', false)
              } else {
                res.data.forEach(item => {
                  item.BusinessOpenTimeId = item.Id
                  item.BusinessRoleId = parseInt(message)
                  item.Week = [
                    {
                      WeekDay: 'Sunday',
                      Enable: false,
                      People: null
                    },
                    {
                      WeekDay: 'Monday',
                      Enable: false,
                      People: null
                    },
                    {
                      WeekDay: 'TuesDay',
                      Enable: false,
                      People: null
                    },
                    {
                      WeekDay: 'Wednesday',
                      Enable: false,
                      People: null
                    },
                    {
                      WeekDay: 'Thursday',
                      Enable: false,
                      People: null
                    },
                    {
                      WeekDay: 'Friday',
                      Enable: false,
                      People: null
                    },
                    {
                      WeekDay: 'Saturday',
                      Enable: false,
                      People: null
                    }
                  ]
                  delete item.Id
                  delete item.BusinessUserId
                })
                context.commit('roleTime', res.data)
                context.commit('loading', false)
              }
            })
            .catch(error => console.error(error))
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 搜尋網路與現場預約資料
    search (context, str) {
      const adminEmail = JSON.parse(sessionStorage.getItem('admin'))
      Vue.axios
        .get('http://imrebooksystem.rocket-coding.com/BusinessUsers/GetUserInfo', {
          params: { email: adminEmail }
        })
        .then(res => {
          const id = res.data.Id
          // 網路
          Vue.axios
            .get('http://imrebooksystem.rocket-coding.com/Dashboard/SearchNetWorkPeople', {
              params: { id: id, keyWord: str }
            })
            .then(function (res) {
              if (res.data !== '查無此筆資料') {
                context.commit('bookInfo', res.data)
              } else {
                context.commit('bookInfo', { NetWorkBookInfo: [] })
              }
            })
            .catch(error => console.error(error))
          // 取得角色清單
          Vue.axios
            .get('http://imrebooksystem.rocket-coding.com/BusinessRoles/GetRoleList', {
              params: { id: id }
            })
            .then(res => {
              const roleList = res.data
              // 現場
              Vue.axios
                .get('http://imrebooksystem.rocket-coding.com/Dashboard/SearchLivePeople', {
                  params: { id: id, keyWord: str }
                })
                .then(function (res) {
                  if (res.data !== '查無此筆資料') {
                    res.data.forEach(element => {
                      roleList.forEach(item => {
                        if (element.BusinessRoleId === item.Id) {
                          element.roleName = item.BusinessRoleName
                        }
                      })
                    })
                    context.commit('liveBookInfo', { NetWorkBookInfo: res.data })
                  } else {
                    context.commit('liveBookInfo', { NetWorkBookInfo: [] })
                  }
                })
                .catch(error => console.error(error))
            })
            .catch(error => {
              console.error(error)
            })
          // 現場
          // Vue.axios
          //   .get('http://imrebooksystem.rocket-coding.com/Dashboard/SearchLivePeople', {
          //     params: { id: res.data.Id, keyWord: str }
          //   })
          //   .then(function (res) {
          //     if (res.data !== '查無此筆資料') {
          //       context.commit('liveBookInfo', res.data)
          //     }
          //   })
          //   .catch(error => console.error(error))
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 取得使用者資料
    userData (context, val) {
      console.log(val)
      Vue.axios
        .get('http://imrebooksystem.rocket-coding.com/CustomerUsers/GetUserInfo', {
          params: { phone: val.phone, password: val.pwd }
        })
        .then(res => {
          sessionStorage.setItem('user', JSON.stringify(res.data))
          location.reload()
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
})
